module.exports = __webpack_public_path__ + "media/images/icons/tip-ec7b2b081e901079b60368e87854c8ee.svg";